export const isHostnameOrganizationSubDomain = () => {
  if (typeof window === "undefined") return false;

  const envHostName = process.env.NEXT_PUBLIC_TACTIC_DOMAIN || "";
  const hostname = window.location.hostname;

  const escapedEnvHostName = envHostName.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

  // Regex: <subdomain>.<envHostName>
  const organizationSubdomainRegex = new RegExp(
    `^[a-z0-9]+(?:-[a-z0-9]+)*\\.${escapedEnvHostName}$`,
    "i"
  );

  return organizationSubdomainRegex.test(hostname);
};
